$(function () {
    if ($("#rd-section-pri1").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-pri1",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-pri1").addClass("ani_do").removeClass("op0");
            },
        });
    }
});
